<div class="dtr-field" [ngClass]="'dtr-label-' + labelPosition">
    <label *ngIf="label" class="dtr-label">{{ label }}</label>
    <div class="date-range-container" ngbDropdown #dr="ngbDropdown" [placement]="placement"
        [container]="dropdownContainer">
        <button class="date-btn" ngbDropdownToggle [ngStyle]="{'width': calendarBarWidth + 'px'}"
            [ngbTooltip]="tooltipText" container="body" tooltipClass="date-range-tooltip"
            [ngClass]="{ 'icon-left': iconPosition == 'left'}" [disabled]="disabled">
            <span *ngIf="currentTimeSelected" class="btn-label">{{currentTimeSelected.name}}</span>
            <span *ngIf="!currentTimeSelected" class="selected-date-range"
                [ngStyle]="{'max-width': (calendarBarWidth - 30) + 'px'}">
                {{ toJSDate(fromDate) | date:'MMM dd, yyyy' }} - {{ toJSDate(toDate) | date:'MMM dd, yyyy' }}
            </span>
            <span class="material-symbols-outlined calendar-icon">calendar_today</span>
        </button>

        <div ngbDropdownMenu #dropdownMenu class="date-range-menu" (click)="handleHostClick($event)">
            <div class="date-range-content" [ngStyle]="{'max-width': calendarWidth + 'px'}">
                <div class="presets" *ngIf="showSidePanel">
                    <kt-date-field-selector *ngIf="showDateRangeSelector"
                        [defaultDateField]="defaultDateField"></kt-date-field-selector>
                    <div class="preset-options custom-scrollbar">
                        <div *ngIf="showPresetLabel" class="preset-header">
                            Show by
                        </div>
                        <div *ngFor="let t of presetsToDisplay" (click)="selectTimeWindow(t)" class="preset-option">
                            <div class="preset-value"
                                [ngClass]="{'preset-selected': t.name===currentTimeSelected?.name}">{{
                                t.name}} <mat-icon *ngIf="t.name===currentTimeSelected?.name"
                                    class="calendar-icon">done</mat-icon></div>
                        </div>
                    </div>
                </div>
                <div class="calendar">
                    <div class="calendar-body" [ngClass]="{
                    'year-view-left': yearSelectionSide === 'left',
                    'year-view-right': yearSelectionSide === 'right',
                    'month-view-left': monthSelectionSide === 'left',
                    'month-view-right': monthSelectionSide === 'right'
                }">
                        <div *ngIf="yearSelectionSide" class="year-grid custom-scrollbar"
                            [ngClass]="{'year-grid-right': yearSelectionSide === 'right'}">
                            <button type="button" class="year-cell" *ngFor="let year of yearOptions"
                                (click)="selectYear(year)"
                                [ngClass]="{'year-selected': yearSelectionSide === 'left' ? year === visibleFromMonth?.year : year === visibleToMonth?.year}">
                                {{ year }}
                            </button>
                        </div>
                        <div *ngIf="monthSelectionSide" class="month-grid"
                            [ngClass]="{'month-grid-right': monthSelectionSide === 'right'}">
                            <button type="button" class="month-cell" *ngFor="let month of monthOptions"
                                (click)="selectMonth(month.index)"
                                [ngClass]="{'month-selected': monthSelectionSide === 'left' ? month.index === visibleFromMonth?.month : month.index === visibleToMonth?.month}">
                                {{ month.name }}
                            </button>
                        </div>
                        <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" navigation="arrows"
                            outsideDays="hidden" (navigate)="onCalendarNavigate($event)"
                            [displayMonths]="displayedMonths" [dayTemplate]="dayTemplate" class="picker"
                            [ngStyle]="{'width': calendarWidth + 'px'}">
                        </ngb-datepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #dayTemplate let-date let-focused="focused">
    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.inside]="isInside(date)">{{
        date.day }}</span>
</ng-template>